export default __webpack_public_path__ + "static/media/img-slider-token-3.1534742c.png";